module.exports = __webpack_public_path__ + "static/img/weather_034.429c4e3a.svg";